export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', seq: 'cat-shoes-01' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', seq: 'cat-hoodies-02' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line', seq: 'cat-tshirts-03' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-handbag-line', seq: 'cat-jackets-04' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line', seq: 'cat-pants-05' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-star-line', seq: 'cat-headwear-06' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', seq: 'cat-sets-07' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-archive-line', seq: 'cat-underwear-08' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line', seq: 'cat-jersey-09' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line', seq: 'cat-accessories-10' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line', seq: 'cat-bags-11' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link', seq: 'cat-belts-12' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line', seq: 'cat-perfumes-13' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', seq: 'cat-other-14' },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Fast Product Discovery',
    description: 'Find popular products quickly with our organized spreadsheet database. No more endless scrolling through marketplaces.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Better Shopping Decisions',
    description: 'Compare products side by side with detailed specifications, pricing breakdowns, and real user feedback.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'Learn Sugargoo step by step with clear guides, tutorials, and tips designed for first-time international shoppers.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Resources',
    description: 'Follow the latest shopping trends with regularly updated spreadsheets, new finds, and fresh recommendations.',
  },
];